import { MachineActivity } from './machinaries/machineActivity';
import { FieldActivityItem } from './fieldActivityItem';
import { Crop } from './crop';
import { Field } from './field';
import { Equipment } from './equipment';
import { User } from './user';
import { FieldActivityMix } from './fieldActivityMix';
import { CropSubUnit } from './cropSubUnit';
import { SustainabilityIndexes } from './sustainabilityIndexes';
import { EquipmentActivityTarget } from './equipmentActivityTarget';
import { TenantGeneralData } from './tenantGeneralData';
import { EquipmentsUsage } from './equipmentsUsage';
import { FieldActivityProducts } from './fieldActivityProduct';

export class FieldActivity extends TenantGeneralData {
  uuid: string;
  type: any;
  workHours: number;
  workedMinutes: number;
  mixes: Array<FieldActivityMix>;
  volume: number; // SOLO Per 1. Difesa e 2. Nutrizione
  volumeUnit: string; // SOLO Per 1. Difesa e 2. Nutrizione
  techAuthorization: boolean; // SOLO Per 1. Difesa e 2. Nutrizione
  note: string;
  distributionMethod: string;
  verification: string;
  verificationDate: Date;
  activityDate: Date;
  dateCreated: Date;
  lastUpdated: Date;
  field: Field;
  crop: Crop;
  cropObj: Crop;
  equipments: Array<Equipment>;
  users: Array<User>;
  applicationMethod: string;
  phenologicalStage: string;
  phenologicalStageStatus?: number;
  done: boolean;
  fieldActivityItems: Array<FieldActivityItem>;
  cropYear: number;
  externalSource: string;
  infestationLevel: string;
  interventionReason: string;
  startWorkingTimeHourOfDay: number;
  startWorkingTimeMinOfDay: number;
  endWorkingTimeHourOfDay: number;
  endWorkingTimeMinOfDay: number;
  machineActivities: Array<MachineActivity>;
  meteoBlueStatus: string;
  temperature: number;
  humidity: number;
  wind: number;
  rainLast24h: number;
  from: Date = null;
  to: Date = null;
  plannedPeriodFrom: Date = null;
  plannedPeriodTo: Date = null;
  multipleCrops?: Array<Crop>;
  workedHectares: number;
  numberDaysToStart?: number;
  title?: string;
  automaticActions: Array<string>;
  cropSubUnits?: Array<CropSubUnit> = [];
  closeCrops: boolean;
  sustainabilityIndexes?: Array<SustainabilityIndexes>;
  isSustainabilityIndexComputable?: boolean;
  isSustainabilityCoefficientPresent?: boolean;
  bufferZone: boolean;
  reachingThreshold: boolean;
  customType: any;
  equipmentsTargets: Array<EquipmentActivityTarget>;
  cropResiduesDestination: string;
  tillageDepth?: string;
  isBasicFeeding: boolean = false;
  equipmentsUsage: EquipmentsUsage[] = null;
  companyName?: string;
  fieldName?: string;
  employeeData?: any;
  cropName?: string;
  variety?: string;
  fieldSize?: string;
  treatmentEfficacy: string;
  analyzedSample?: string;
  analysisReportNumber?: string;
  activeSubstancesDetected?: string;
  analysisSupplierId?: number;
  attachments?: Array<string>;
  isTransSeeding?: boolean;
  status: string;
  products?: Array<FieldActivityProducts>;

  constructor() {
    super();
    this.id = null;
    this.uuid = null;
    this.type = null;
    this.workHours = null;
    this.workedMinutes = null;
    this.mixes = null;
    this.volume = null; // SOLO Per 1. Difesa e 2. Nutrizione
    this.volumeUnit = null; // SOLO Per 1. Difesa e 2. Nutrizione
    this.techAuthorization = null; // SOLO Per 1. Difesa e 2. Nutrizione
    this.note = null;
    this.title = null;
    this.distributionMethod = null;
    this.verification = null;
    this.activityDate = null;
    this.verificationDate = null;
    this.dateCreated = null;
    this.lastUpdated = null;
    this.field = null;
    this.crop = null;
    this.cropObj = null;
    this.users = null;
    this.applicationMethod = null;
    this.phenologicalStage = null;
    this.phenologicalStageStatus = null;
    this.done = true;
    this.fieldActivityItems = [];
    this.cropYear = null;
    this.externalSource = null;
    this.infestationLevel = null;
    this.interventionReason = null;
    this.startWorkingTimeHourOfDay = null;
    this.startWorkingTimeMinOfDay = null;
    this.endWorkingTimeHourOfDay = null;
    this.endWorkingTimeMinOfDay = null;
    this.meteoBlueStatus = null;
    this.temperature = null;
    this.humidity = null;
    this.wind = null;
    this.rainLast24h = null;
    this.from = null;
    this.to = null;
    this.plannedPeriodFrom = null;
    this.plannedPeriodTo = null;
    this.workedHectares = null;
    this.machineActivities = [];
    this.numberDaysToStart = null;
    this.automaticActions = null;
    this.cropSubUnits = [];
    this.closeCrops = false;
    this.sustainabilityIndexes = [];
    this.isSustainabilityIndexComputable = false;
    this.isSustainabilityCoefficientPresent = false;
    this.bufferZone = false;
    this.reachingThreshold = false;
    this.customType = null;
    this.equipmentsTargets = null;
    this.cropResiduesDestination = null;
    this.tillageDepth = null;
    this.equipmentsUsage = null;
    this.treatmentEfficacy = null;
    this.analyzedSample = null;
    this.analysisReportNumber = null;
    this.activeSubstancesDetected = null;
    this.analysisSupplierId = null;
    this.attachments = null;
    this.isTransSeeding = false;
    this.status = null;
  }
}

export interface LastDoneActivityFromFieldResponse {
  totalSize: number;
  content: {
    id: number;
    type: string;
    activityDate: string;
    cropYear: number;
    done: boolean;
    field: {
      id: number;
      name: string;
      size: number;
    };
  }[];
}
